<template>
    <div class="wrap">
        <div class="container lnb" style="position: relative">
            <div class="contents_wrap" style="height: 100%;">
                <div class="contents">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <div class="">
                        <lookbook-write-component :lookbookType="'createLookbook'"></lookbook-write-component>
                    </div>
                </div>
            </div>
            <div class="" style="text-align: center;">
                <el-button @click="submitForm()" type="primary">저장</el-button>
            </div>
            <page-footer></page-footer>
        </div>
        <lookbook-item-modal></lookbook-item-modal>
    </div>
</template>

<script>
import EventBus from "@/mixins/event-bus";
import LookbookWriteComponent from "@/components/lookbook/LookbookWriteComponent";
import LookbookItemModal from "@/components/modal/LookbookItemModal";

export default {
    name: 'LookbookWrite',
    components: {
        LookbookItemModal,
        LookbookWriteComponent
    },
    mixins: [],
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
        submitForm() {
            EventBus.$emit('writeLookbook');
        },
    },
    watch: {}
}
</script>

<style lang="scss" scoped>

</style>
